
import { Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { ExecutionResult, IAppRegistrationModel } from "@tylertech/tyler-api-types";

/**
 * AppService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class AppService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetAppsByModule(moduleName: string): Promise<ExecutionResult<IAppRegistrationModel[]>> {
        return this.$apiService.sendAuth("IAppService/GetAppsByModule", moduleName);
    }
    GetFavoriteApps(): Promise<ExecutionResult<IAppRegistrationModel[]>> {
        return this.$apiService.sendAuth("IAppService/GetFavoriteApps");
    }
    RegisterApps(): Promise<ExecutionResult<IAppRegistrationModel[]>> {
        return this.$apiService.sendAuth("IAppService/RegisterApps");
    }
    RegisterModules(): Promise<ExecutionResult<IAppRegistrationModel[]>> {
        return this.$apiService.sendAuth("IAppService/RegisterModules");
    }
}
